const routes = {
    login: "api/login",
    logout: "api/logout",
    partners: {
        get: "api/Partner?paged=true&page=pageNumber&pagesize=9999&complete=true",
        getBySlug: "api/Partner/bySlug?complete=true&slug=:slug",
        spotlight: "api/Partner/spotlight?complete=true",
    },
    partnerCategories: {
        get: "api/PartnerCategory?paged=true&page=pageNumber&pagesize=9999&complete=true",
        byId: "api/PartnerCategory/:id",
    },
    users: {
        all:'api/Users',
        myUser: 'api/users/myuser?complete=true',
        updatePassword: 'api/users/updatepassword',
        recoverPassword: 'api/users/recoverpassword',
        activateUser: 'api/users/ActivateUser/',
        deleteImage: 'api/users/deleteimage/:id',
        addUser: 'api/Users',
        updateUser:'api/users/UpdateMyUser',
        getNewTerms: 'api/users/showTermPopup',
        updateNewTerms: 'api/users/UpdateCheckTerm',
        deleteMyUser: 'api/users/DeleteMyUser',
    },
    girocard: {
        all: 'api/girocard',
        byId: 'api/girocard/:id',
        blockCardCredit: 'api/girocard/blockcard/credit',
        myCards: 'api/girocard/mycards',
        blockCard: 'api/girocard/blockcard/'
    },
    paymentCard:{
        all:'api/paymentCard',
        byId:'api/paymentCard/:id'
    },
    faleConosco: {
        enviar: 'api/Contact'
    },
    terms:{
        getActive:'api/termsandconditions/getactive'
    },
    faqs:{
        getAll:'api/FAQ?paged=false&page=1&pagesize=10&complete=true',
        getAllCategories: 'api/FAQCategory?paged=false&complete=true&hasFaq=true',
        getByCategory: 'api/FAQCategory/:id?paged=false&complete=true'
    },
    images:{
        getImage:'api/Image/GetActive'
    },
    PrivacyPolicy:{
        getActive:'api/privacypolicy/getactive'
    },
    Promotion:{
        getActive:'api/promotion/getactive'
    },
    recarga: {
        cupom:'api/coupon/:cupom'         
    },
    sbe:{
        fare:'api/sbe/fare',
        cashback:'api/sbe/cashback',
        blockCard:'api/sbe/blockCard',
        order:'api/sbe/order',
        checkCard:'api/sbe/checkCard',
        cardPending:'api/sbe/cardPending',
        cardHistory:'api/sbe/cardHistory'
    },
    qrcode: {
        evento: {
            ativo:'api/qrcode/evento/ativo'
        },
        ativos:'api/qrcode/ativos',
        comprados:'api/qrcode/comprados',
        comprar:'api/qrcode/order',
        detalhe:'api/qrcode/comprados/:id',
        pdf:'api/qrcode/pdf'
    },
}

export default routes;